import React from "react";

const Button = ({children}) => (
    <button className="button">{children}</button>
)

export default Button;